import React from 'react';
import { FiFileText } from "react-icons/fi";

function SelectedDocumentList({ sourcePlace, data }) {
    const uniqueDocumentsMap = new Map();
    (data?.documentNames || []).forEach(doc => {
        if (doc?.documentId && !uniqueDocumentsMap.has(doc.documentId)) {
            uniqueDocumentsMap.set(doc.documentId, doc);
        }
    });
    const uniqueDocuments = Array.from(uniqueDocumentsMap.values());

    return (
        <div style={styles.card}>
            <div style={styles.header}>
                Documents
            </div>
            <div style={styles.listContainer}>
                {uniqueDocuments?.length > 0 ? (
                    uniqueDocuments.map((doc, index) => (
                        <div key={index} style={styles.listItem}>
                            <div style={styles.bullet}><FiFileText /></div>
                            <div style={styles.docName} title={doc?.documentName}>
                                {doc?.documentName}
                            </div>
                        </div>
                    ))
                ) : (
                    <div style={styles.emptyText}>No documents selected.</div>
                )}
            </div>
        </div>
    );
}
const styles = {
    card: {
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
        // padding: '16px',
        // maxWidth: '500px',
        width: '100%',
        fontFamily: 'Arial, sans-serif',
    },
    header: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#333',
        margin: '12px 0',
    },
    listContainer: {
        maxHeight: '250px',
        overflowY: 'auto',
        paddingRight: '4px',
    },
    listItem: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
        color: '#555',
    },
    bullet: {
        marginRight: '8px',
        fontSize: '16px',
        color: '#0F67C5',
    },
    docName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        flex: 1,
        color: '#333',
    },
    emptyText: {
        fontStyle: 'italic',
        color: '#999',
        fontSize: '14px',
    },
};
export default SelectedDocumentList;
